'use strict';

angular.module('licensure.services')
    .factory('PolicyClassifications', ['$http', '$q', function ($http, $q) {

        var get = function (type) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/policyclassifications', {
                    params: {
                        type: type
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function() {
                return get(null);
            },

            getPolicy: function () {
                return get('Policy');
            },

            getProtocol: function () {
                return get('Protocol');
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/policyclassifications/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
;